module.exports = __webpack_public_path__ + "static/media/bbwexe_sfx.7cba8aa3.mp3";